<script>
  import { fade } from 'svelte/transition'
  import MediaQuery from './MediaQuery.svelte'

  export let labelInfo
  export let sidebarWidth = 100
</script>

<div class="wrapper" transition:fade style="
--width: {sidebarWidth}px;
">
  <div class="fonts">
    <h1>{labelInfo.name}</h1>
    <ul>
      {#each labelInfo.fontList as font}
        <li>
          <p>
            <a
              href={font.path}
              title="View this font on Typofonderie">{@html font.name}
              {#if font.OT}<span class="OT">{font.OT}</span>{/if}
            </a>
          </p>
        </li>
      {/each}
    </ul>
  </div>
  <div class="reference">
    <h2><a href={labelInfo.ref.link} title="View the book">Reference</a></h2>
    <MediaQuery query="(min-width: 600px)" let:matches>
      {#if matches}
        <p class="ref-text">{labelInfo.ref.text}</p>
      {/if}
    </MediaQuery>
  </div>
</div>

<style lang="scss">
  @import '../responsive.scss';
  .wrapper {
    z-index: 1;
    position: fixed;
    width: var(--width);

    @include for-tablet-p {
      width: 100vw;
      bottom: 0;
      left: 0;
      background-color: var(--dark);
      display: grid;
      grid-template-columns: 1fr 1fr;
      padding: 1em 2em;

      .fonts {
        grid-column: 1;
        li {
          display: inline-block;
          margin-right: 10px;
        }
        @include for-phone {
          grid-column: 1 / span 2;
        }
      }
      .reference {
        grid-column: 2;
        h2 {
          margin-top: 8px;
        }
        @include for-phone {
          grid-column: 1 / span 2;
          grid-row: 2;
        }
      }
    }
  }
  li {
    margin-bottom: 10px;
  }
  h1 {
    font-family: 'Arteria-Bold';
    font-size: 3.5rem;
    line-height: 1em;
    margin-bottom: 10px;
    color: var(--red);

    @include for-tablet {
      font-size: 2.5rem;
    }

    @include for-phone {
      font-size: 2rem;
    }
  }
  h2 {
    margin-top: 30px;
    font-family: 'Arteria-Bold';
    font-size: 2.5rem;
    color: var(--red);
    text-transform: uppercase;

    @include for-tablet {
      font-size: 1.8rem;
    }
    @include for-phone {
      font-size: 1.5rem;
    }
  }
  a {
    font-family: 'Arteria-Regular';
    font-size: 2.5rem;
    color: var(--light);

    @include for-tablet {
      font-size: 1.8rem;
    }
    @include for-phone {
      font-size: 1.5rem;
    }
  }
  .OT {
    font-family: 'Arteria-Regular';
    font-size: 2rem;
    color: var(--red);
    margin-left: 5px;

    @include for-tablet {
      font-size: 1.7rem;
    }
    @include for-phone {
      font-size: 1.5rem;
    }
  }
  a {
    &:hover {
      color: var(--red);
    }
    &:hover::after {
      color: var(--red);
    }
    &::after {
      bottom: 4px;
      position: relative;
      font-family: 'mencken-std-text', serif;
      font-size: 1.4rem;
      content: ' \2192';
      color: var(--green);

      @include for-tablet {
        bottom: 4px;
        font-size: 1rem;
      }
    }
  }
  .ref-text {
    font-family: 'mencken-std-text';
    font-size: 1.3rem;
    color: var(--light);
    line-height: 1.3em;
    margin-bottom: 10px;

    @include for-tablet {
      font-size: 1rem;
    }
  }
</style>
